var items = {
  "block.minecraft.air": "ჰაერი",
  "block.minecraft.stone": "ქვა",
  "block.minecraft.granite": "გრანიტი",
  "block.minecraft.polished_granite": "გაპრიალებული გრანიტი",
  "block.minecraft.diorite": "დიორიტი",
  "block.minecraft.polished_diorite": "გაპრიალებული დიორიტი",
  "block.minecraft.andesite": "ანდეზიტი",
  "block.minecraft.polished_andesite": "გაპრიალებული ანდეზიტი",
  "block.minecraft.grass_block": "ბალახის ბლოკი",
  "block.minecraft.dirt": "მიწა",
  "block.minecraft.coarse_dirt": "გამომშრალი მიწა",
  "block.minecraft.podzol": "ეწერი",
  "block.minecraft.crimson_nylium": "ჟოლოსფერი ნილიუმი",
  "block.minecraft.warped_nylium": "დაბრეცილი ნილიუმი",
  "block.minecraft.cobblestone": "რიყის ქვა",
  "block.minecraft.oak_planks": "მუხის ფიცრები",
  "block.minecraft.spruce_planks": "ნაძვის ხის ფიცრები",
  "block.minecraft.birch_planks": "არყის ფილა",
  "block.minecraft.jungle_planks": "ტროპიკული ხის ფილა",
  "block.minecraft.acacia_planks": "აკაციის ფილა",
  "block.minecraft.dark_oak_planks": "მუქი მუხის ფიცრები",
  "block.minecraft.crimson_planks": "ჟოლოსფერი ფიცრები",
  "block.minecraft.warped_planks": "უცნაური ფიცრები",
  "block.minecraft.oak_sapling": "მუხის ნერგი",
  "block.minecraft.spruce_sapling": "ნაძვის ნერგი",
  "block.minecraft.birch_sapling": "არყის ნერგი",
  "block.minecraft.jungle_sapling": "ჯუნგლის ხის ნერგი",
  "block.minecraft.acacia_sapling": "აკაციის ნერგი",
  "block.minecraft.dark_oak_sapling": "მუქი მუხის ნერგი",
  "block.minecraft.bedrock": "საძირკვლო ქვა",
  "block.minecraft.sand": "ქვიშა",
  "block.minecraft.red_sand": "წითელი ქვიშა",
  "block.minecraft.gravel": "ხრეში",
  "block.minecraft.gold_ore": "ოქროს მადანი",
  "block.minecraft.iron_ore": "რკინის მადანი",
  "block.minecraft.coal_ore": "ქვანახშირის მადანი",
  "block.minecraft.nether_gold_ore": "ნეზერის ოქროს მადანი",
  "block.minecraft.oak_log": "მუხის მორი",
  "block.minecraft.spruce_log": "ნაძვის მორი",
  "block.minecraft.birch_log": "არყის ხის მორი",
  "block.minecraft.jungle_log": "ტროპიკული ხის მორი",
  "block.minecraft.acacia_log": "აკაციის მორი",
  "block.minecraft.dark_oak_log": "მუქი მუხის მორი",
  "block.minecraft.crimson_stem": "ჟოლოსფერი ღერო",
  "block.minecraft.warped_stem": "დაბრეცილი ღერო",
  "block.minecraft.stripped_oak_log": "გათლილი მუხის მორი",
  "block.minecraft.stripped_spruce_log": "გათლილი ნაძვის მორი",
  "block.minecraft.stripped_birch_log": "გათლილი არყის ხის მორი",
  "block.minecraft.stripped_jungle_log": "გათლილი ტროპიკული ხის მორი",
  "block.minecraft.stripped_acacia_log": "გათლილი აკაციის მორი",
  "block.minecraft.stripped_dark_oak_log": "გათლილი მუქი მუხის მორი",
  "block.minecraft.stripped_crimson_stem": "გათლილი ჟოლოსფერი ღერო",
  "block.minecraft.stripped_warped_stem": "გათლილი დაბრეცილი ღერო",
  "block.minecraft.stripped_oak_wood": "გათლილი მუხა",
  "block.minecraft.stripped_spruce_wood": "გათლილი ნაძვი",
  "block.minecraft.stripped_birch_wood": "გათლილი არყის ხე",
  "block.minecraft.stripped_jungle_wood": "გათლილი ტროპიკული ხე",
  "block.minecraft.stripped_acacia_wood": "გათლილი აკაცია",
  "block.minecraft.stripped_dark_oak_wood": "გათლილი მუქი მუხა",
  "block.minecraft.stripped_crimson_hyphae": "უქერქო ჟოლოსფერი ბლოკი",
  "block.minecraft.stripped_warped_hyphae": "გათლილი დაბრეცილი ბოჭკო",
  "block.minecraft.oak_wood": "მუხის ხე",
  "block.minecraft.spruce_wood": "ნაძვის ხე",
  "block.minecraft.birch_wood": "არყის ხე",
  "block.minecraft.jungle_wood": "ჯუნგლის ხე",
  "block.minecraft.acacia_wood": "აკაციის ხე",
  "block.minecraft.dark_oak_wood": "მუქი მუხის ხე",
  "block.minecraft.crimson_hyphae": "ჟოლოსფერი ბლოკი",
  "block.minecraft.warped_hyphae": "დაბრეცილი ბოჭკო",
  "block.minecraft.oak_leaves": "მუხის ფოთლები",
  "block.minecraft.spruce_leaves": "ნაძვის ფოთლები",
  "block.minecraft.birch_leaves": "არყის ფოთლები",
  "block.minecraft.jungle_leaves": "ჯუნგლის ფოთლები",
  "block.minecraft.acacia_leaves": "აკაციის ფოთლები",
  "block.minecraft.dark_oak_leaves": "მუქი მუხის ფოთლები",
  "block.minecraft.sponge": "ღრუბელი",
  "block.minecraft.wet_sponge": "სველი ღრუბელი",
  "block.minecraft.glass": "შუშა",
  "block.minecraft.lapis_ore": "ლილაქვის მადანი",
  "block.minecraft.lapis_block": "ლილაქვის ბლოკი",
  "block.minecraft.dispenser": "გამტყორცნი",
  "block.minecraft.sandstone": "ქვიშაქვა",
  "block.minecraft.chiseled_sandstone": "მოპირკეთებული ქვიშაქვა",
  "block.minecraft.cut_sandstone": "მოჭრილი ქვიშაქვა",
  "block.minecraft.note_block": "მუსიკალური ბლოკი",
  "block.minecraft.powered_rail": "ამაჩქარებელი",
  "block.minecraft.detector_rail": "მგრძნობიარე რელსი",
  "block.minecraft.sticky_piston": "წებოვანი დგუში",
  "block.minecraft.cobweb": "აბლაბუდა",
  "block.minecraft.grass": "ბალახი",
  "block.minecraft.fern": "გვიმრა",
  "block.minecraft.dead_bush": "გამხმარი ბუჩქი",
  "block.minecraft.seagrass": "წყლის ბალახი",
  "block.minecraft.sea_pickle": "ზღვის კიტრი",
  "block.minecraft.piston": "დგუში",
  "block.minecraft.white_wool": "თეთრი მატყლი",
  "block.minecraft.orange_wool": "ნარინჯისფერი მატყლი",
  "block.minecraft.magenta_wool": "იასამნისფერი მატყლი",
  "block.minecraft.light_blue_wool": "ღია-ლურჯი მატყლი",
  "block.minecraft.yellow_wool": "ყვითელი მატყლი",
  "block.minecraft.lime_wool": "სალათისფერი მატყლი",
  "block.minecraft.pink_wool": "ვარდისფერი მატყლი",
  "block.minecraft.gray_wool": "ნაცრისფერი მატყლი",
  "block.minecraft.light_gray_wool": "ღია-ნაცრისფერი მატყლი",
  "block.minecraft.cyan_wool": "ცისფერი მატყლი",
  "block.minecraft.purple_wool": "ალისფერი მატყლი",
  "block.minecraft.blue_wool": "ლურჯი მატყლი",
  "block.minecraft.brown_wool": "ყავისფერი მატყლი",
  "block.minecraft.green_wool": "მწვანე მატყლი",
  "block.minecraft.red_wool": "წითელი მატყლი",
  "block.minecraft.black_wool": "შავი მატყლი",
  "block.minecraft.dandelion": "ბაბუაწვერა",
  "block.minecraft.poppy": "ყაყაჩო",
  "block.minecraft.blue_orchid": "ლურჯი ორქიდეა",
  "block.minecraft.allium": "ხახვი",
  "block.minecraft.azure_bluet": "ცისფერი ბლუეტი",
  "block.minecraft.red_tulip": "წითელი ტიტა",
  "block.minecraft.orange_tulip": "ნარინჯისფერი ტიტა",
  "block.minecraft.white_tulip": "თეთრი ტიტა",
  "block.minecraft.pink_tulip": "ვარდისფერი ტიტა",
  "block.minecraft.oxeye_daisy": "გვირილა",
  "block.minecraft.cornflower": "ლურჯი ყვავილი",
  "block.minecraft.lily_of_the_valley": "შროშანი",
  "block.minecraft.wither_rose": "ვიდერის ვარდი",
  "block.minecraft.brown_mushroom": "ყავისფერი სოკო",
  "block.minecraft.red_mushroom": "წითელი სოკო",
  "block.minecraft.crimson_fungus": "ჟოლოსფერი სოკო",
  "block.minecraft.warped_fungus": "უცნაური სოკო",
  "block.minecraft.crimson_roots": "ჟოლოსფერი ფესვები",
  "block.minecraft.warped_roots": "უცნაური ფესვები",
  "block.minecraft.nether_sprouts": "ნეზერის ყლორტები",
  "block.minecraft.weeping_vines": "მტირალა ვაზი",
  "block.minecraft.twisting_vines": "გრეხა ვაზები",
  "block.minecraft.sugar_cane": "შაქრის ლერწამი",
  "block.minecraft.kelp": "კელპი",
  "block.minecraft.bamboo": "ბამბუკი",
  "block.minecraft.gold_block": "ოქროს ბლოკი",
  "block.minecraft.iron_block": "რკინის ბლოკი",
  "block.minecraft.oak_slab": "მუხის ფილა",
  "block.minecraft.spruce_slab": "ნაძვის ხის ფილა",
  "block.minecraft.birch_slab": "არყის ფილა",
  "block.minecraft.jungle_slab": "ტროპიკული ხის ფილა",
  "block.minecraft.acacia_slab": "აკაციის ფილა",
  "block.minecraft.dark_oak_slab": "მუქი მუხის ფილა",
  "block.minecraft.crimson_slab": "ჟოლოსფერი ფილა",
  "block.minecraft.warped_slab": "დაბრეცილი ფილა",
  "block.minecraft.stone_slab": "ქვის ფილა",
  "block.minecraft.smooth_stone_slab": "გლუვი ქვის ფილა",
  "block.minecraft.sandstone_slab": "ქვიშაქვის ფილა",
  "block.minecraft.cut_sandstone_slab": "დაჭრილი ქვიშაქვის ფილა",
  "block.minecraft.petrified_oak_slab": "გაქვავებული მუხის ფილა",
  "block.minecraft.cobblestone_slab": "რიყის ქვის ფილა",
  "block.minecraft.brick_slab": "აგურის ფილა",
  "block.minecraft.stone_brick_slab": "ქვის აგურის ფილა",
  "block.minecraft.nether_brick_slab": "ნეზერის აგურის ფილა",
  "block.minecraft.quartz_slab": "კვარცის ფილა",
  "block.minecraft.red_sandstone_slab": "წითელი ქვიშაქვის ფილა",
  "block.minecraft.cut_red_sandstone_slab": "დაჭრილი წითელი ქვიშაქვის ფილა",
  "block.minecraft.purpur_slab": "პურპურის ფილა",
  "block.minecraft.prismarine_slab": "პრიზმარინის ფილა",
  "block.minecraft.prismarine_brick_slab": "პრიზმარინის აგურის ფილა",
  "block.minecraft.dark_prismarine_slab": "მუქი პრიზმარინის ფილა",
  "block.minecraft.smooth_quartz": "გლუვი კვარცის ბლოკი",
  "block.minecraft.smooth_red_sandstone": "გლუვი წითელი ქვიშაქვა",
  "block.minecraft.smooth_sandstone": "გლუვი ქვეშაქვა",
  "block.minecraft.smooth_stone": "გლუვი ქვა",
  "block.minecraft.bricks": "აგურები",
  "block.minecraft.tnt": "ტროტილი",
  "block.minecraft.bookshelf": "წიგნის თარო",
  "block.minecraft.mossy_cobblestone": "ხავსიანი რიყის ქვა",
  "block.minecraft.obsidian": "ობსიდიანი",
  "block.minecraft.torch": "ჩირაღდანი",
  "block.minecraft.end_rod": "ენდის ჯოხი",
  "block.minecraft.chorus_plant": "ქორუსი",
  "block.minecraft.chorus_flower": "ქორუსის ყვავილი",
  "block.minecraft.purpur_block": "პურპურის ბლოკი",
  "block.minecraft.purpur_pillar": "პურპურის სვეტი",
  "block.minecraft.purpur_stairs": "პურპურის საფეხურები",
  "block.minecraft.spawner": "სპავნერი",
  "block.minecraft.oak_stairs": "მუხის საფეხურები",
  "block.minecraft.chest": "სკივრი",
  "block.minecraft.diamond_ore": "ალმასის მადანი",
  "block.minecraft.diamond_block": "ალმასის ბლოკი",
  "block.minecraft.crafting_table": "დაზგა",
  "block.minecraft.farmland": "დამუშავებული მიწა",
  "block.minecraft.furnace": "ღუმელი",
  "block.minecraft.ladder": "კიბე",
  "block.minecraft.rail": "რელსი",
  "block.minecraft.cobblestone_stairs": "ქვის საფეხურები",
  "block.minecraft.lever": "ბერკეტი",
  "block.minecraft.stone_pressure_plate": "ქვის მგრძნობიარე ფილა",
  "block.minecraft.oak_pressure_plate": "მუხის ზეწოლის ფილა",
  "block.minecraft.spruce_pressure_plate": "ნაძვის ხის ფირფიტა",
  "block.minecraft.birch_pressure_plate": "არყის ხის ფირფიტა",
  "block.minecraft.jungle_pressure_plate": "ტროპიკული ხის ფირფიტა",
  "block.minecraft.acacia_pressure_plate": "აკაციის ხის ფირფიტა",
  "block.minecraft.dark_oak_pressure_plate": "მუქი მუხის ზეწოლის ფილა",
  "block.minecraft.crimson_pressure_plate": "ჟოლოსფერი ფირფიტა",
  "block.minecraft.warped_pressure_plate": "უცნაური მგრძნობიარე ფილა",
  "block.minecraft.polished_blackstone_pressure_plate": "გაპრიალებული შავქვის ფირფიტა",
  "block.minecraft.redstone_ore": "რედსტოუნის მადანი",
  "block.minecraft.redstone_torch": "რედსტოუნის ჩირაღდანი",
  "block.minecraft.snow": "თოვლი",
  "block.minecraft.ice": "ყინული",
  "block.minecraft.snow_block": "თოვლის ბლოკი",
  "block.minecraft.cactus": "კაქტუსი",
  "block.minecraft.clay": "თიხა",
  "block.minecraft.jukebox": "დამკვრელი",
  "block.minecraft.oak_fence": "მუხის ღობე",
  "block.minecraft.spruce_fence": "ნაძვის ღობე",
  "block.minecraft.birch_fence": "არყის ღობე",
  "block.minecraft.jungle_fence": "ჯუნგლის ღობე",
  "block.minecraft.acacia_fence": "აკაციის ღობე",
  "block.minecraft.dark_oak_fence": "მუქი მუხის ღობე",
  "block.minecraft.crimson_fence": "ჟოლოსფერი ღობე",
  "block.minecraft.warped_fence": "უცნაური ღობე",
  "block.minecraft.pumpkin": "გოგრა",
  "block.minecraft.carved_pumpkin": "გამოჭრილი გოგრა",
  "block.minecraft.netherrack": "ნეზერაკი",
  "block.minecraft.soul_sand": "სულთა ქვიშა",
  "block.minecraft.soul_soil": "სულის მიწა",
  "block.minecraft.basalt": "ბაზალტი",
  "block.minecraft.polished_basalt": "გაპრიალებული ბაზალტი",
  "block.minecraft.soul_torch": "სულის ჩირაღდანი",
  "block.minecraft.glowstone": "ნათობქვა",
  "block.minecraft.jack_o_lantern": "მანათობელი გოგრა",
  "block.minecraft.oak_trapdoor": "მუხის ლუქი",
  "block.minecraft.spruce_trapdoor": "ნაძვის ლუქი",
  "block.minecraft.birch_trapdoor": "არყის ხის ლუქი",
  "block.minecraft.jungle_trapdoor": "ტროპიკული ხის ლუქი",
  "block.minecraft.acacia_trapdoor": "აკაციის ლუქი",
  "block.minecraft.dark_oak_trapdoor": "მუქი მუხის ლუქი",
  "block.minecraft.crimson_trapdoor": "ჟოლოსფერი ლუქი",
  "block.minecraft.warped_trapdoor": "უცნაური საძვრენი კარი",
  "block.minecraft.infested_stone": "მონსტრის ქვა",
  "block.minecraft.infested_cobblestone": "მონსტრის რიყის ქვა",
  "block.minecraft.infested_stone_bricks": "მონსტრის აგურქვა",
  "block.minecraft.infested_mossy_stone_bricks": "მონსტრის ლიანიანი აგურქვა",
  "block.minecraft.infested_cracked_stone_bricks": "მონსტრის გატეხილი აგურქვა",
  "block.minecraft.infested_chiseled_stone_bricks": "მონსტრის მოკაზმული აგურქვა",
  "block.minecraft.stone_bricks": "ქვის აგურები",
  "block.minecraft.mossy_stone_bricks": "ხავსიანი ქვის აგურები",
  "block.minecraft.cracked_stone_bricks": "გაბზარული ქვის აგურები",
  "block.minecraft.chiseled_stone_bricks": "მოპირკეთებული ქვის აგურები",
  "block.minecraft.brown_mushroom_block": "ყავისფერი სოკოს ბლოკი",
  "block.minecraft.red_mushroom_block": "წითელი სოკოს ბლოკი",
  "block.minecraft.mushroom_stem": "სოკოს სუპი",
  "block.minecraft.iron_bars": "რკინის გისოსები",
  "block.minecraft.chain": "ჯაჭვი",
  "block.minecraft.glass_pane": "შუშის პანელი",
  "block.minecraft.melon": "საზამთრო",
  "block.minecraft.vine": "სურო",
  "block.minecraft.oak_fence_gate": "მუხის ღობის ჭიშკარი",
  "block.minecraft.spruce_fence_gate": "ნაძვის ღობის ჭიშკარი",
  "block.minecraft.birch_fence_gate": "არყის ღობის ჭიშკარი",
  "block.minecraft.jungle_fence_gate": "ჯუნგლის ღობის ჭიშკარი",
  "block.minecraft.acacia_fence_gate": "აკაციის ღობის ჭიშკარი",
  "block.minecraft.dark_oak_fence_gate": "მუქი მუხის ღობის ჭიშკარი",
  "block.minecraft.crimson_fence_gate": "ჟოლოსფერი ჭიშკარი",
  "block.minecraft.warped_fence_gate": "დაბრეცილი ჭიშკარი",
  "block.minecraft.brick_stairs": "აგურის საფეხურები",
  "block.minecraft.stone_brick_stairs": "ქვის აგურის საფეხურები",
  "block.minecraft.mycelium": "მიცელიუმი",
  "block.minecraft.lily_pad": "ლილიას ფოთოლი",
  "block.minecraft.nether_bricks": "ნეზერის აგური",
  "block.minecraft.cracked_nether_bricks": "გაბზარული ნეზერის აგური",
  "block.minecraft.chiseled_nether_bricks": "სხვადასხვა ნეზერის აგურები",
  "block.minecraft.nether_brick_fence": "ნეზერის აგურის ღობე",
  "block.minecraft.nether_brick_stairs": "ნეზერის აგურის საფეხურები",
  "block.minecraft.enchanting_table": "მოჯადოების მაგიდა",
  "block.minecraft.end_portal_frame": "ენდის პორტალის ჩარჩო",
  "block.minecraft.end_stone": "სასრულქვა",
  "block.minecraft.end_stone_bricks": "ენდის ქვის აგურები",
  "block.minecraft.dragon_egg": "დრაკონის კვერცხი",
  "block.minecraft.redstone_lamp": "რედსტოუნის ნათურა",
  "block.minecraft.sandstone_stairs": "ქვიშაქვის საფეხურები",
  "block.minecraft.emerald_ore": "ზურმუხტის მადანი",
  "block.minecraft.ender_chest": "ენდერის სკივრი",
  "block.minecraft.tripwire_hook": "ხაფანგის კაუჭი",
  "block.minecraft.emerald_block": "ზურმუხტის ბლოკი",
  "block.minecraft.spruce_stairs": "ნაძვის საფეხურები",
  "block.minecraft.birch_stairs": "არყის საფეხურები",
  "block.minecraft.jungle_stairs": "ტროპიკული ხის საფეხურები",
  "block.minecraft.crimson_stairs": "ჟოლოსფერი საფეხურები",
  "block.minecraft.warped_stairs": "დაბრეცილი საფეხურები",
  "block.minecraft.command_block": "ბრძანების ბლოკი",
  "block.minecraft.beacon": "შუქურა",
  "block.minecraft.cobblestone_wall": "რიყის ქვის კედელი",
  "block.minecraft.mossy_cobblestone_wall": "ხავსიანი რიყის ქვის კედელი",
  "block.minecraft.brick_wall": "აგურის კედელი",
  "block.minecraft.prismarine_wall": "პრიზმარინის კედელი",
  "block.minecraft.red_sandstone_wall": "წითელი ქვიშაქვის კედელი",
  "block.minecraft.mossy_stone_brick_wall": "ანდეზიტის კედელი",
  "block.minecraft.granite_wall": "გრანიტის კედელი",
  "block.minecraft.stone_brick_wall": "ქვა აგურის კედელი",
  "block.minecraft.nether_brick_wall": "ნეზერის აგურის კედელი",
  "block.minecraft.andesite_wall": "ანდეზიტის კედელი",
  "block.minecraft.red_nether_brick_wall": "წითელი ნეზერის აგურის კედელი",
  "block.minecraft.sandstone_wall": "ქვიშაქვის კედელი",
  "block.minecraft.end_stone_brick_wall": "ენდის ქვა აგურის კედელი",
  "block.minecraft.diorite_wall": "დიორიტის კედელი",
  "block.minecraft.blackstone_wall": "შავქვის კედელი",
  "block.minecraft.polished_blackstone_wall": "გაპრიალებული შავქვის კედელი",
  "block.minecraft.polished_blackstone_brick_wall": "გაპრიალებული შავქვის აგურების კედელი",
  "block.minecraft.stone_button": "ქვის ღილაკი",
  "block.minecraft.oak_button": "ღილაკი მუხისგან",
  "block.minecraft.spruce_button": "ნაძვის ღილაკი",
  "block.minecraft.birch_button": "ღილაკი არყის ხისგან",
  "block.minecraft.jungle_button": "ღილაკი ტროპიკული ხისგან",
  "block.minecraft.acacia_button": "ღილაკი აკაციის ხისგან",
  "block.minecraft.dark_oak_button": "ღილაკი მუქი მუხისგან",
  "block.minecraft.crimson_button": "ჟოლოსფერი ღილაკი",
  "block.minecraft.warped_button": "უცნაური ღილაკი",
  "block.minecraft.polished_blackstone_button": "გაპრიალებული შავქვის ღილაკი",
  "block.minecraft.anvil": "გრდემლი",
  "block.minecraft.chipped_anvil": "დაზიანებული გრდემლი",
  "block.minecraft.damaged_anvil": "გატეხილი გრდემლი",
  "block.minecraft.trapped_chest": "ხაფანგიანი სკივრი",
  "block.minecraft.light_weighted_pressure_plate": "მსუბუქი წონადობის ფირფიტა",
  "block.minecraft.heavy_weighted_pressure_plate": "მძიმე წონადობის დასაჭერი ფირფიტა",
  "block.minecraft.daylight_detector": "სინათლის დეტექტორი",
  "block.minecraft.redstone_block": "რედსტოუნის ბლოკი",
  "block.minecraft.nether_quartz_ore": "ნეზერის კვარცის მადანი",
  "block.minecraft.hopper": "ძაბრი",
  "block.minecraft.chiseled_quartz_block": "გამოქანდაკებული კვარცის ბლოკი",
  "block.minecraft.quartz_block": "კვარცის ბლოკი",
  "block.minecraft.quartz_bricks": "კვარცის აგურები",
  "block.minecraft.quartz_pillar": "კვარცის სვეტი",
  "block.minecraft.quartz_stairs": "კვარცის საფეხურები",
  "block.minecraft.activator_rail": "ჩამრთველი რელსი",
  "block.minecraft.dropper": "დამყრელი",
  "block.minecraft.white_terracotta": "თეთრი ტერაკოტა",
  "block.minecraft.orange_terracotta": "ნარინჯისფერი ტერაკოტა",
  "block.minecraft.magenta_terracotta": "იასამნისფერი ტერაკოტა",
  "block.minecraft.light_blue_terracotta": "ღია-ლურჯი ტერაკოტა",
  "block.minecraft.yellow_terracotta": "ყვითელი ტერაკოტა",
  "block.minecraft.lime_terracotta": "სალათისფერი ტერაკოტა",
  "block.minecraft.pink_terracotta": "ვარდისფერი ტერაკოტა",
  "block.minecraft.gray_terracotta": "ნაცრისფერი ტერაკოტა",
  "block.minecraft.light_gray_terracotta": "ღია-ნაცრისფერი ტერაკოტა",
  "block.minecraft.cyan_terracotta": "ცისფერი ტერაკოტა",
  "block.minecraft.purple_terracotta": "ალისფერი ტერაკოტა",
  "block.minecraft.blue_terracotta": "ლურჯი ტერაკოტა",
  "block.minecraft.brown_terracotta": "ყავისფერი ტერაკოტა",
  "block.minecraft.green_terracotta": "მწვანე ტერაკოტა",
  "block.minecraft.red_terracotta": "წითელი ტერაკოტა",
  "block.minecraft.black_terracotta": "შავი ტერაკოტა",
  "block.minecraft.barrier": "ბარიერი",
  "block.minecraft.iron_trapdoor": "რკინის საძვრენი",
  "block.minecraft.hay_block": "თივის შეკვრა",
  "block.minecraft.white_carpet": "თეთრი ხალიჩა",
  "block.minecraft.orange_carpet": "ნარინჯისფერი ხალიჩა",
  "block.minecraft.magenta_carpet": "იასამნისფერი ხალიჩა",
  "block.minecraft.light_blue_carpet": "ღია-ლურჯი ხალიჩა",
  "block.minecraft.yellow_carpet": "ყვითელი ხალიჩა",
  "block.minecraft.lime_carpet": "სალათისფერი ხალიჩა",
  "block.minecraft.pink_carpet": "ვარდისფერი ხალიჩა",
  "block.minecraft.gray_carpet": "ნაცრისფერი ხალიჩა",
  "block.minecraft.light_gray_carpet": "ღია-ნაცრისფერი ხალიჩა",
  "block.minecraft.cyan_carpet": "ცისფერი ხალიჩა",
  "block.minecraft.purple_carpet": "ალისფერი ხალიჩა",
  "block.minecraft.blue_carpet": "ლურჯი ხალიჩა",
  "block.minecraft.brown_carpet": "ყავისფერი ხალიჩა",
  "block.minecraft.green_carpet": "მწვანე ხალიჩა",
  "block.minecraft.red_carpet": "წითელი ხალიჩა",
  "block.minecraft.black_carpet": "შავი ხალიჩა",
  "block.minecraft.terracotta": "ტერაკოტა",
  "block.minecraft.coal_block": "ქვანახშირის ბლოკი",
  "block.minecraft.packed_ice": "მკვრივი ყინული",
  "block.minecraft.acacia_stairs": "აკაციის საფეხურები",
  "block.minecraft.dark_oak_stairs": "მუქი მუხის საფეხურები",
  "block.minecraft.slime_block": "ლორწოს ბლოკი",
  "block.minecraft.grass_path": "ბილიკი",
  "block.minecraft.sunflower": "მზესუმზირა",
  "block.minecraft.lilac": "იასამანი",
  "block.minecraft.rose_bush": "ვარდის ბუჩქი",
  "block.minecraft.peony": "იორდასალამი",
  "block.minecraft.tall_grass": "მაღალი ბალახი",
  "block.minecraft.large_fern": "დიდი გვიმრა",
  "block.minecraft.white_stained_glass": "თეთრი შუშა",
  "block.minecraft.orange_stained_glass": "ნარინჯისფერი შუშა",
  "block.minecraft.magenta_stained_glass": "იასამნისფერი შუშა",
  "block.minecraft.light_blue_stained_glass": "ღია-ლურჯი შუშა",
  "block.minecraft.yellow_stained_glass": "ყვითელი შუშა",
  "block.minecraft.lime_stained_glass": "სალათისფერი შუშა",
  "block.minecraft.pink_stained_glass": "ვარდისფერი შუშა",
  "block.minecraft.gray_stained_glass": "ნაცრისფერი შუშა",
  "block.minecraft.light_gray_stained_glass": "ღია-ნაცრისფერი შუშა",
  "block.minecraft.cyan_stained_glass": "ცისფერი შუშა",
  "block.minecraft.purple_stained_glass": "ალისფერი შუშა",
  "block.minecraft.blue_stained_glass": "ლურჯი შუშა",
  "block.minecraft.brown_stained_glass": "ყავისფერი შუშა",
  "block.minecraft.green_stained_glass": "მწვანე შუშა",
  "block.minecraft.red_stained_glass": "წითელი შუშა",
  "block.minecraft.black_stained_glass": "შავი შუშა",
  "block.minecraft.white_stained_glass_pane": "თეთრი შუშის პანელი",
  "block.minecraft.orange_stained_glass_pane": "ნარინჯისფერი შუშის პანელი",
  "block.minecraft.magenta_stained_glass_pane": "იასამნისფერი შუშის პანელი",
  "block.minecraft.light_blue_stained_glass_pane": "ღია-ცისფერი შუშის პანელი",
  "block.minecraft.yellow_stained_glass_pane": "ყვითელი შუშის პანელი",
  "block.minecraft.lime_stained_glass_pane": "სალათისფერი შუშის პანელი",
  "block.minecraft.pink_stained_glass_pane": "ვარდისფერი შუშის პანელი",
  "block.minecraft.gray_stained_glass_pane": "ნაცრისფერი შუშის პანელი",
  "block.minecraft.light_gray_stained_glass_pane": "ღია-ნაცრისფერი შუშის პანელი",
  "block.minecraft.cyan_stained_glass_pane": "ცისფერი შუშის პანელი",
  "block.minecraft.purple_stained_glass_pane": "ალისფერი შუშის პანელი",
  "block.minecraft.blue_stained_glass_pane": "ლურჯი შუშის პანელი",
  "block.minecraft.brown_stained_glass_pane": "ყავისფერი შუშის პანელი",
  "block.minecraft.green_stained_glass_pane": "მწვანე შუშის პანელი",
  "block.minecraft.red_stained_glass_pane": "წითელი შუშის პანელი",
  "block.minecraft.black_stained_glass_pane": "შავი შუშის პანელი",
  "block.minecraft.prismarine": "პრიზმარინი",
  "block.minecraft.prismarine_bricks": "პრიზმარინის აგურები",
  "block.minecraft.dark_prismarine": "მუქი პრიზმარინი",
  "block.minecraft.prismarine_stairs": "პრიზმარინის საფეხურები",
  "block.minecraft.prismarine_brick_stairs": "პრიზმარინის აგურის საფეხურები",
  "block.minecraft.dark_prismarine_stairs": "მუქი პრიზმარინის საფეხურები",
  "block.minecraft.sea_lantern": "ზღვის სანათი",
  "block.minecraft.red_sandstone": "წითელი ქვიშაქვა",
  "block.minecraft.chiseled_red_sandstone": "მოპირკეთებული წითელი ქვიშაქვა",
  "block.minecraft.cut_red_sandstone": "მოჭრილი წითელი ქვიშაქვა",
  "block.minecraft.red_sandstone_stairs": "წითელი ქვიშაქვის საფეხურები",
  "block.minecraft.repeating_command_block": "განმეორებელი ბრძანების ბლოკი",
  "block.minecraft.chain_command_block": "ჯაჭვური ბრძანების ბლოკი",
  "block.minecraft.magma_block": "მაგმის ბლოკი",
  "block.minecraft.nether_wart_block": "ნეზერის მეჭეჭას ბლოკი",
  "block.minecraft.warped_wart_block": "ჯოჯოხეთის მეჭეჭის ბლოკი",
  "block.minecraft.red_nether_bricks": "წითელი ნეზერის აგური",
  "block.minecraft.bone_block": "ძვლის ბლოკი",
  "block.minecraft.structure_void": "ცარიელი ბლოკი",
  "block.minecraft.observer": "მეთვალყურე",
  "block.minecraft.shulker_box": "შალკერის ყუთი",
  "block.minecraft.white_shulker_box": "თეთრი შულკერის ყუთი",
  "block.minecraft.orange_shulker_box": "ნარინჯისფერი შულკერის ყუთი",
  "block.minecraft.magenta_shulker_box": "იასამნისფერი შულკერის ყუთი",
  "block.minecraft.light_blue_shulker_box": "ღია-ლურჯი შულკერის ყუთი",
  "block.minecraft.yellow_shulker_box": "ყვითელი შულკერის ყუთი",
  "block.minecraft.lime_shulker_box": "სალათისფერი შულკერის ყუთი",
  "block.minecraft.pink_shulker_box": "ვარდისფერი შულკერის ყუთი",
  "block.minecraft.gray_shulker_box": "ნაცრისფერი შულკერის ყუთი",
  "block.minecraft.light_gray_shulker_box": "ღია-ნაცრისფერი შულკერის ყუთი",
  "block.minecraft.cyan_shulker_box": "ცისფერი შულკერის ყუთი",
  "block.minecraft.purple_shulker_box": "ალისფერი შულკერის ყუთი",
  "block.minecraft.blue_shulker_box": "ლურჯი შულკერის ყუთი",
  "block.minecraft.brown_shulker_box": "ყავისფერი შულკერის ყუთი",
  "block.minecraft.green_shulker_box": "მწვანე შულკერის ყუთი",
  "block.minecraft.red_shulker_box": "წითელი შულკერის ყუთი",
  "block.minecraft.black_shulker_box": "შავი შულკერის ყუთი",
  "block.minecraft.white_glazed_terracotta": "თეთრი მოჭიქული ტერაკოტა",
  "block.minecraft.orange_glazed_terracotta": "ნარინჯისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.magenta_glazed_terracotta": "იასამნისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.light_blue_glazed_terracotta": "ღია-ლურჯი მოჭიქული ტერაკოტა",
  "block.minecraft.yellow_glazed_terracotta": "ყვითელი მოჭიქული ტერაკოტა",
  "block.minecraft.lime_glazed_terracotta": "სალათისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.pink_glazed_terracotta": "ვარდისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.gray_glazed_terracotta": "ნაცრისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.light_gray_glazed_terracotta": "ღია-ნაცრისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.cyan_glazed_terracotta": "ცისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.purple_glazed_terracotta": "ალისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.blue_glazed_terracotta": "ლურჯი მოჭიქული ტერაკოტა",
  "block.minecraft.brown_glazed_terracotta": "ყავისფერი მოჭიქული ტერაკოტა",
  "block.minecraft.green_glazed_terracotta": "მწვანე მოჭიქული ტერაკოტა",
  "block.minecraft.red_glazed_terracotta": "წითელი მოჭიქული ტერაკოტა",
  "block.minecraft.black_glazed_terracotta": "შავი მოჭიქული ტერაკოტა",
  "block.minecraft.white_concrete": "თეთრი ბეტონი",
  "block.minecraft.orange_concrete": "ნარინჯისფერი ბეტონი",
  "block.minecraft.magenta_concrete": "იასამნისფერი ბეტონი",
  "block.minecraft.light_blue_concrete": "ღია-ლურჯი ბეტონი",
  "block.minecraft.yellow_concrete": "ყვითელი ბეტონი",
  "block.minecraft.lime_concrete": "სალათისფერი ბეტონი",
  "block.minecraft.pink_concrete": "ვარდისფერი ბეტონი",
  "block.minecraft.gray_concrete": "ნაცრისფერი ბეტონი",
  "block.minecraft.light_gray_concrete": "ღია-ნაცრისფერი ბეტონი",
  "block.minecraft.cyan_concrete": "ცისფერი ბეტონი",
  "block.minecraft.purple_concrete": "ალისფერი ბეტონი",
  "block.minecraft.blue_concrete": "ლურჯი ბეტონი",
  "block.minecraft.brown_concrete": "ყავისფერი ბეტონი",
  "block.minecraft.green_concrete": "მწვანე ბეტონი",
  "block.minecraft.red_concrete": "წითელი ბეტონი",
  "block.minecraft.black_concrete": "შავი ბეტონი",
  "block.minecraft.white_concrete_powder": "თეთრი ცემენტი",
  "block.minecraft.orange_concrete_powder": "ნარინჯისფერი ცემენტი",
  "block.minecraft.magenta_concrete_powder": "იასამნისფერი ცემენტი",
  "block.minecraft.light_blue_concrete_powder": "ღია-ლურჯი ცემენტი",
  "block.minecraft.yellow_concrete_powder": "ყვითელი ცემენტი",
  "block.minecraft.lime_concrete_powder": "სალათისფერი ცემენტი",
  "block.minecraft.pink_concrete_powder": "ვარდისფერი ცემენტი",
  "block.minecraft.gray_concrete_powder": "ნაცრისფერი ცემენტი",
  "block.minecraft.light_gray_concrete_powder": "ღია-ნაცრისფერი ცემენტი",
  "block.minecraft.cyan_concrete_powder": "ცისფერი ცემენტი",
  "block.minecraft.purple_concrete_powder": "ალისფერი ცემენტი",
  "block.minecraft.blue_concrete_powder": "ლურჯი ცემენტი",
  "block.minecraft.brown_concrete_powder": "ყავისფერი ცემენტი",
  "block.minecraft.green_concrete_powder": "მწვანე ცემენტი",
  "block.minecraft.red_concrete_powder": "წითელი ცემენტი",
  "block.minecraft.black_concrete_powder": "შავი ცემენტი",
  "block.minecraft.turtle_egg": "კუს კვერცხი",
  "block.minecraft.dead_tube_coral_block": "მკვდარი მილის მარჯნის ბლოკი",
  "block.minecraft.dead_brain_coral_block": "მკვდარი ტვინის მარჯნის ბლოკი",
  "block.minecraft.dead_bubble_coral_block": "მკვდარი ბუშტის მარჯნის ბლოკი",
  "block.minecraft.dead_fire_coral_block": "მკვდარი ცეცხლის მარჯნის მცენარის ბლოკი",
  "block.minecraft.dead_horn_coral_block": "მკვდარი ხვრელიანი მარჯნის ბლოკი",
  "block.minecraft.tube_coral_block": "მილის მარჯნის ბლოკი",
  "block.minecraft.brain_coral_block": "ტვინის მარჯნის ბლოკი",
  "block.minecraft.bubble_coral_block": "ბუშტის მარჯნის ბლოკი",
  "block.minecraft.fire_coral_block": "ცეცხლის მარჯნის ბლოკი",
  "block.minecraft.horn_coral_block": "ნახვრეტიანი მარჯნის ბლოკი",
  "block.minecraft.tube_coral": "მილის მარჯანი",
  "block.minecraft.brain_coral": "ტვინის მარჯანი",
  "block.minecraft.bubble_coral": "ბუშტის მარჯანი",
  "block.minecraft.fire_coral": "ცეცხლის მარჯანი",
  "block.minecraft.horn_coral": "ხვრელიანი მარჯანი",
  "block.minecraft.dead_brain_coral": "მკვდარი ტვინის მარჯანი",
  "block.minecraft.dead_bubble_coral": "მკვდარი ბუსტის მარჯანი",
  "block.minecraft.dead_fire_coral": "მკვდარი ცეცხლის მარჯანი",
  "block.minecraft.dead_horn_coral": "მკვდარი ხვრელიანი მარჯანი",
  "block.minecraft.dead_tube_coral": "მკვდარი მილის მარჯანი",
  "block.minecraft.tube_coral_fan": "მილის მარჯნის მცენარე",
  "block.minecraft.brain_coral_fan": "ტვინის მარჯნის მცენარე",
  "block.minecraft.bubble_coral_fan": "ბუშტის მარჯნის მცენარე",
  "block.minecraft.fire_coral_fan": "ცეცხლის მარჯნის მცენარე",
  "block.minecraft.horn_coral_fan": "ხვრელიანი მარჯნის მცენარე",
  "block.minecraft.dead_tube_coral_fan": "მკვდარი მილის მარჯნის მცენარე",
  "block.minecraft.dead_brain_coral_fan": "მკვდარი ტვინის მარჯნის მცენარე",
  "block.minecraft.dead_bubble_coral_fan": "მკვდარი ბუშტის მარჯნის მცენარე",
  "block.minecraft.dead_fire_coral_fan": "მკვდარი ცეცხლის მარჯნის მცენარე",
  "block.minecraft.dead_horn_coral_fan": "მკვდარი ხვრელიანი მარჯნის მცენარე",
  "block.minecraft.blue_ice": "ლურჯი ყინული",
  "block.minecraft.conduit": "მილი",
  "block.minecraft.polished_granite_stairs": "გაპრიალებული გრანიტის საფეხურები",
  "block.minecraft.smooth_red_sandstone_stairs": "გლუვი წითელი ქვიშაქვის საფეხურები",
  "block.minecraft.mossy_stone_brick_stairs": "ხავსიანი ქვის აგურის საფეხურები",
  "block.minecraft.polished_diorite_stairs": "გაპრიალებული დიორიტის საფეხურები",
  "block.minecraft.mossy_cobblestone_stairs": "ხავსიანი რიყის ქვის საფეხურები",
  "block.minecraft.end_stone_brick_stairs": "ენდ ქვის აგურის საფეხურები",
  "block.minecraft.stone_stairs": "ქვის საფეხურები",
  "block.minecraft.smooth_sandstone_stairs": "გლუვი ქვიშაქვის საფეხურები",
  "block.minecraft.smooth_quartz_stairs": "გლუვი კვარცის საფეხურე",
  "block.minecraft.granite_stairs": "გრანიტის საფეხურები",
  "block.minecraft.andesite_stairs": "ანდეზიტის საფეხურები",
  "block.minecraft.red_nether_brick_stairs": "წითელი ნეზერის აგურის საფეხურები",
  "block.minecraft.polished_andesite_stairs": "გაპრიალებული ანდეზიტის საფეხურები",
  "block.minecraft.diorite_stairs": "დიორიტის საფეხურები",
  "block.minecraft.polished_granite_slab": "გაპრიალებული გრანიტის ფილა",
  "block.minecraft.smooth_red_sandstone_slab": "გლუვი წითელი ქვიშაქვის ფილა",
  "block.minecraft.mossy_stone_brick_slab": "ხავსიანი ქვა აგურის ფილა",
  "block.minecraft.polished_diorite_slab": "გაპრიალებული დიორიტი",
  "block.minecraft.mossy_cobblestone_slab": "ხავსიანი რიყის ქვის ფილა",
  "block.minecraft.end_stone_brick_slab": "ენდ ქვის აგურის საფეხურები",
  "block.minecraft.smooth_sandstone_slab": "გლუვი ქვიშაქვის ფილა",
  "block.minecraft.smooth_quartz_slab": "გლუვი კვარცის ფილა",
  "block.minecraft.granite_slab": "გრანიტის ფილა",
  "block.minecraft.andesite_slab": "ანდეზიტის ფილა",
  "block.minecraft.red_nether_brick_slab": "წითელი ნეზერის აგურის ფილა",
  "block.minecraft.polished_andesite_slab": "გაპრიალებული ანდეზიტის ფილა",
  "block.minecraft.diorite_slab": "დიორიტის ფილა",
  "block.minecraft.scaffolding": "საყრდენი",
  "block.minecraft.iron_door": "რკინის ქარები",
  "block.minecraft.oak_door": "მუხის კარები",
  "block.minecraft.spruce_door": "ნაძვის კარები",
  "block.minecraft.birch_door": "არყის კარები",
  "block.minecraft.jungle_door": "ჯუნგლის კარები",
  "block.minecraft.acacia_door": "აკაციის კარები",
  "block.minecraft.dark_oak_door": "მუქი მუხის კარები",
  "block.minecraft.crimson_door": "ჟოლოსფერი კარი",
  "block.minecraft.warped_door": "უცნაური კარი",
  "block.minecraft.repeater": "რედსტოუნის მამეორებელი",
  "block.minecraft.comparator": "რედსტოუნის კომპარატორი",
  "block.minecraft.structure_block": "კონსტრუქციის ბლოკი",
  "block.minecraft.jigsaw": "თავსატეხი ბლოკი",
  "item.minecraft.turtle_helmet": "კუს ნიჟარა□□როდესაც ფეხები დგომა:□+2 აბჯარი",
  "item.minecraft.scute": "ჯავშანი",
  "item.minecraft.iron_shovel": "რკინის ნიჩაბი□□როდესაც მთავარ ხელშია:□+3.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.iron_pickaxe": "რკინის წერაქვი□□როდესაც მთავარ ხელშია:□+3 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.iron_axe": "რკინის ნაჯახი□□როდესაც მთავარ ხელშია:□+8 შეტევის ზიანი□-3.1 შეტევის სიჩქარე",
  "item.minecraft.flint_and_steel": "კაჟი და ფოლადი",
  "item.minecraft.apple": "ვაშლი",
  "item.minecraft.bow": "მშვილდი",
  "item.minecraft.arrow": "ისარი",
  "item.minecraft.coal": "ქვანახშირი",
  "item.minecraft.charcoal": "ნახშირი",
  "item.minecraft.diamond": "ალმასი",
  "item.minecraft.iron_ingot": "რკინის ზოდი",
  "item.minecraft.gold_ingot": "ოქროს ზოდი",
  "item.minecraft.netherite_ingot": "ნეზერიტის ზოდი",
  "item.minecraft.netherite_scrap": "ნეზერიტის ნატეხი",
  "item.minecraft.iron_sword": "რკინის ხმალი□□როდესაც მთავარ ხელშია:□+5 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.wooden_sword": "ხის ხმალი□□როდესაც მთავარ ხელშია:□+3 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.wooden_shovel": "ხის ნიჩაბი□□როდესაც მთავარ ხელშია:□+1.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.wooden_pickaxe": "ხის წერაქვი□□როდესაც მთავარ ხელშია:□+1 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.wooden_axe": "ხის ნაჯახი□□როდესაც მთავარ ხელშია:□+6 შეტევის ზიანი□-3.2 შეტევის სიჩქარე",
  "item.minecraft.stone_sword": "ქვის ხმალი□□როდესაც მთავარ ხელშია:□+4 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.stone_shovel": "ქვის ნიჩაბი□□როდესაც მთავარ ხელშია:□+2.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.stone_pickaxe": "ქვის წერაქვი□□როდესაც მთავარ ხელშია:□+2 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.stone_axe": "ქვის ნაჯახი□□როდესაც მთავარ ხელშია:□+8 შეტევის ზიანი□-3.2 შეტევის სიჩქარე",
  "item.minecraft.diamond_sword": "ალმასის ხმალი□□როდესაც მთავარ ხელშია:□+6 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.diamond_shovel": "ალმასის ნიჩაბი□□როდესაც მთავარ ხელშია:□+4.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.diamond_pickaxe": "ალმასის წერაქვი□□როდესაც მთავარ ხელშია:□+4 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.diamond_axe": "ალმასის ნაჯახი□□როდესაც მთავარ ხელშია:□+8 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.stick": "ჯოხი",
  "item.minecraft.bowl": "ჯამი",
  "item.minecraft.mushroom_stew": "სოკოს სუპი",
  "item.minecraft.golden_sword": "ოქროს ხმალი□□როდესაც მთავარ ხელშია:□+3 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.golden_shovel": "ოქროს ნიჩაბი□□როდესაც მთავარ ხელშია:□+1.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.golden_pickaxe": "ოქროს წერაქვი□□როდესაც მთავარ ხელშია:□+1 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.golden_axe": "ოქროს ნაჯახი□□როდესაც მთავარ ხელშია:□+6 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.netherite_sword": "ნეზერიტის ხმალი□□როდესაც მთავარ ხელშია:□+7 შეტევის ზიანი□-2.4 შეტევის სიჩქარე",
  "item.minecraft.netherite_shovel": "ნეზერიტის ნიჩაბი□□როდესაც მთავარ ხელშია:□+5.5 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.netherite_pickaxe": "ნეზერიტის წერაქვი□□როდესაც მთავარ ხელშია:□+5 შეტევის ზიანი□-2.8 შეტევის სიჩქარე",
  "item.minecraft.netherite_axe": "ნეზერიტის ნაჯახი□□როდესაც მთავარ ხელშია:□+9 შეტევის ზიანი□-3 შეტევის სიჩქარე",
  "item.minecraft.string": "ძაფი",
  "item.minecraft.feather": "ბუმბული",
  "item.minecraft.gunpowder": "დენთი",
  "item.minecraft.wooden_hoe": "ხის თოხი□□როდესაც მთავარ ხელშია:□-3 შეტევის სიჩქარე",
  "item.minecraft.stone_hoe": "ქვის თოხი□□როდესაც მთავარ ხელშია:□-2 შეტევის სიჩქარე",
  "item.minecraft.iron_hoe": "რკინის თოხი□□როდესაც მთავარ ხელშია:□-1 შეტევის სიჩქარე",
  "item.minecraft.diamond_hoe": "ალმასის თოხი□□როდესაც მთავარ ხელშია:",
  "item.minecraft.golden_hoe": "ოქროს თოხი□□როდესაც მთავარ ხელშია:□-3 შეტევის სიჩქარე",
  "item.minecraft.netherite_hoe": "ნეზერიტის თოხი□□როდესაც მთავარ ხელშია:",
  "item.minecraft.wheat_seeds": "ხორბლის თესლი",
  "item.minecraft.wheat": "ხორბალი",
  "item.minecraft.bread": "პური",
  "item.minecraft.leather_helmet": "ტყავის ქუდი□□როდესაც ფეხები დგომა:□+1 აბჯარი",
  "item.minecraft.leather_chestplate": "ტყავის ქურთუკი□□როდესაც ფეხები დგომა:□+3 აბჯარი",
  "item.minecraft.leather_leggings": "ტყავის შარვალი□□როდესაც ფეხებზე დგომა:□+2 აბჯარი",
  "item.minecraft.leather_boots": "ტყავის ფეხსაცმელი□□when on feet:□+1 აბჯარი",
  "item.minecraft.chainmail_helmet": "ჯაჭვის მუზარადი□□როდესაც ფეხები დგომა:□+2 აბჯარი",
  "item.minecraft.chainmail_chestplate": "ჯაჭვის პერანგი□□როდესაც ფეხები დგომა:□+5 აბჯარი",
  "item.minecraft.chainmail_leggings": "ჯაჭვის შარვალი□□როდესაც ფეხებზე დგომა:□+4 აბჯარი",
  "item.minecraft.chainmail_boots": "ჯაჭვის ფეხსაცმელი□□when on feet:□+1 აბჯარი",
  "item.minecraft.iron_helmet": "რკინის მუზარადი□□როდესაც ფეხები დგომა:□+2 აბჯარი",
  "item.minecraft.iron_chestplate": "რკინის პერანგი□□როდესაც ფეხები დგომა:□+6 აბჯარი",
  "item.minecraft.iron_leggings": "რკინის შარვალი□□როდესაც ფეხებზე დგომა:□+5 აბჯარი",
  "item.minecraft.iron_boots": "რკინის ფეხსაცმელი□□when on feet:□+2 აბჯარი",
  "item.minecraft.diamond_helmet": "ალმასის მუზარადი□□როდესაც ფეხები დგომა:□+3 აბჯარი□+2 აბჯრის სიმაგრე",
  "item.minecraft.diamond_chestplate": "ალმასის პერანგი□□როდესაც ფეხები დგომა:□+8 აბჯარი□+2 აბჯრის სიმაგრე",
  "item.minecraft.diamond_leggings": "ალმასის შარვალი□□როდესაც ფეხებზე დგომა:□+6 აბჯარი□+2 აბჯრის სიმაგრე",
  "item.minecraft.diamond_boots": "ალმასის ფეხსაცმელი□□when on feet:□+3 აბჯარი□+2 აბჯრის სიმაგრე",
  "item.minecraft.golden_helmet": "ოქროს მუზარადი□□როდესაც ფეხები დგომა:□+2 აბჯარი",
  "item.minecraft.golden_chestplate": "ოქროს პერანგი□□როდესაც ფეხები დგომა:□+5 აბჯარი",
  "item.minecraft.golden_leggings": "ოქროს შარვალი□□როდესაც ფეხებზე დგომა:□+3 აბჯარი",
  "item.minecraft.golden_boots": "ოქროს ფეხსაცმელი□□when on feet:□+1 აბჯარი",
  "item.minecraft.netherite_helmet": "ნეზერიტის მუზარადი□□როდესაც ფეხები დგომა:□+3 აბჯარი□+3 აბჯრის სიმაგრე□+1 უკუგდების გამძლეობა",
  "item.minecraft.netherite_chestplate": "ნეზერიტის საგულმკერდე□□როდესაც ფეხები დგომა:□+8 აბჯარი□+3 აბჯრის სიმაგრე□+1 უკუგდების გამძლეობა",
  "item.minecraft.netherite_leggings": "ნეზერიტის შარვალი□□როდესაც ფეხებზე დგომა:□+6 აბჯარი□+3 აბჯრის სიმაგრე□+1 უკუგდების გამძლეობა",
  "item.minecraft.netherite_boots": "ნეზერიტის ფეხსაცმელი□□when on feet:□+3 აბჯარი□+3 აბჯრის სიმაგრე□+1 უკუგდების გამძლეობა",
  "item.minecraft.flint": "კაჟი",
  "item.minecraft.porkchop": "უმი ღორის ხორცი",
  "item.minecraft.cooked_porkchop": "შემწვარი ღორის ხორცი",
  "item.minecraft.painting": "ნახატი",
  "item.minecraft.golden_apple": "ოქროს ვაშლი",
  "item.minecraft.enchanted_golden_apple": "მოჯადოებული ოქროს ვაშლი",
  "block.minecraft.oak_sign": "მუხის დაფა",
  "block.minecraft.spruce_sign": "ნაძვის დაფა",
  "block.minecraft.birch_sign": "არყის დაფა",
  "block.minecraft.jungle_sign": "ტროპიკული ხის დაფა",
  "block.minecraft.acacia_sign": "აკაციის დაფა",
  "block.minecraft.dark_oak_sign": "მუქი მუხის დაფა",
  "block.minecraft.crimson_sign": "ჟოლოსფერი დაფა",
  "block.minecraft.warped_sign": "უცნაური ნიშანი",
  "item.minecraft.bucket": "სათლი",
  "item.minecraft.water_bucket": "წყლიანი სათლი",
  "item.minecraft.lava_bucket": "ლავიანი სათლი",
  "item.minecraft.minecart": "ურიკა",
  "item.minecraft.saddle": "უნაგირი",
  "item.minecraft.redstone": "რედსტოუნის მტვერი",
  "item.minecraft.snowball": "თოვლის გუნდა",
  "item.minecraft.oak_boat": "მუხის ნავი",
  "item.minecraft.leather": "ტყავი",
  "item.minecraft.milk_bucket": "რძის სათლი",
  "item.minecraft.pufferfish_bucket": "ფუგით სავსე სათლი",
  "item.minecraft.salmon_bucket": "სალმონით სავსე სათლი",
  "item.minecraft.cod_bucket": "ქოდით სავსე სათლი",
  "item.minecraft.tropical_fish_bucket": "ტროპიკული თევზით სავსე სათლი",
  "item.minecraft.brick": "აგური",
  "item.minecraft.clay_ball": "თიხის ბურთი",
  "block.minecraft.dried_kelp_block": "გამომშრალი ლამინარიების ბლოკი",
  "item.minecraft.paper": "ქაღალდი",
  "item.minecraft.book": "წიგნი",
  "item.minecraft.slime_ball": "ლორწო",
  "item.minecraft.chest_minecart": "სკივრიანი ურიკა",
  "item.minecraft.furnace_minecart": "ძრავიანი ურიკა",
  "item.minecraft.egg": "კვერცხი",
  "item.minecraft.compass": "კომპასი",
  "item.minecraft.fishing_rod": "სათევზაო ანკესი",
  "item.minecraft.clock": "საათი",
  "item.minecraft.glowstone_dust": "ნათობქვის მტვერი",
  "item.minecraft.cod": "უმი ქოდი",
  "item.minecraft.salmon": "უმი ორაგული",
  "item.minecraft.tropical_fish": "ტროპიკული თევზი",
  "item.minecraft.pufferfish": "ფუგუ",
  "item.minecraft.cooked_cod": "შემწვარი ქოდი",
  "item.minecraft.cooked_salmon": "შემწვარი ორაგული",
  "item.minecraft.ink_sac": "სამელნე",
  "item.minecraft.red_dye": "წითელი საღებავი",
  "item.minecraft.green_dye": "მწვანე საღებავი",
  "item.minecraft.cocoa_beans": "კაკაოს მარცვლები",
  "item.minecraft.lapis_lazuli": "ლილაქვა",
  "item.minecraft.purple_dye": "იისფერი საღებავი",
  "item.minecraft.cyan_dye": "ცისფერი საღებავი",
  "item.minecraft.light_gray_dye": "ღია-რუხი საღებავი",
  "item.minecraft.gray_dye": "რუხი საღებავი",
  "item.minecraft.pink_dye": "ვარდისფერი საღებავი",
  "item.minecraft.lime_dye": "სალათისფერი საღებავი",
  "item.minecraft.yellow_dye": "ყვითელი საღებავი",
  "item.minecraft.light_blue_dye": "ღია-ლურჯი საღებავი",
  "item.minecraft.magenta_dye": "იასამნისფერი საღებავი",
  "item.minecraft.orange_dye": "ნარინჯისფერი საღებავი",
  "item.minecraft.bone_meal": "ძვლის ფხვნილი",
  "item.minecraft.blue_dye": "ლურჯი საღებავი",
  "item.minecraft.brown_dye": "ყავისფერი საღებავი",
  "item.minecraft.black_dye": "შავი საღებავი",
  "item.minecraft.white_dye": "თეთრი საღებავი",
  "item.minecraft.bone": "ძვალი",
  "item.minecraft.sugar": "შაქარი",
  "block.minecraft.cake": "ტორტი",
  "block.minecraft.white_bed": "თეთრი საწოლი",
  "block.minecraft.orange_bed": "ნარინჯისფერი საწოლი",
  "block.minecraft.magenta_bed": "იასამნისფერი საწოლი",
  "block.minecraft.light_blue_bed": "ღია-ლურჯი საწოლი",
  "block.minecraft.yellow_bed": "ყვითელი საწოლი",
  "block.minecraft.lime_bed": "სალათისფერი საწოლი",
  "block.minecraft.pink_bed": "ვარდისფერი საწოლი",
  "block.minecraft.gray_bed": "ნაცრისფერი საწოლი",
  "block.minecraft.light_gray_bed": "ღია-ნაცრისფერი საწოლი",
  "block.minecraft.cyan_bed": "ცისფერი საწოლი",
  "block.minecraft.purple_bed": "ალისფერი საწოლი",
  "block.minecraft.blue_bed": "ლურჯი საწოლი",
  "block.minecraft.brown_bed": "ყავისფერი საწოლი",
  "block.minecraft.green_bed": "მწვანე საწოლი",
  "block.minecraft.red_bed": "წითელი საწოლი",
  "block.minecraft.black_bed": "შავი საწოლი",
  "item.minecraft.cookie": "ნამცხვარი",
  "item.minecraft.filled_map": "რუკა□#0",
  "item.minecraft.shears": "მაკრატელი",
  "item.minecraft.melon_slice": "საზამთროს ნაჭერი",
  "item.minecraft.dried_kelp": "გამომშრალი კელპი",
  "item.minecraft.pumpkin_seeds": "გოგრის თესლი",
  "item.minecraft.melon_seeds": "საზამთროს თესლი",
  "item.minecraft.beef": "უმი საქონლის ხორცი",
  "item.minecraft.cooked_beef": "შემწვარი საქონლის ხორცი",
  "item.minecraft.chicken": "უმი ქათამი",
  "item.minecraft.cooked_chicken": "შემწვარი ქათამი",
  "item.minecraft.rotten_flesh": "ზომბის ხორცი",
  "item.minecraft.ender_pearl": "ენდერის მარგალიტი",
  "item.minecraft.blaze_rod": "ცეცხლას ჯოხი",
  "item.minecraft.ghast_tear": "გასტის ცრემლი",
  "item.minecraft.gold_nugget": "ოქროს ნატეხი",
  "item.minecraft.nether_wart": "ნეზერის მეჭეჭა",
  "item.minecraft.potion": "შეუქმნადი ხსნარი□ეფექტების გარეშე",
  "item.minecraft.glass_bottle": "შუშის ბოთლი",
  "item.minecraft.spider_eye": "ობობის თვალი",
  "item.minecraft.fermented_spider_eye": "გადამუშავებული ობობის თვალი",
  "item.minecraft.blaze_powder": "ცეცხლას ფხვნილი",
  "item.minecraft.magma_cream": "მაგმის კრემი",
  "block.minecraft.brewing_stand": "სახარში ქურა",
  "block.minecraft.cauldron": "ქვაბი",
  "item.minecraft.ender_eye": "ენდერის თვალი",
  "item.minecraft.glistering_melon_slice": "მოოქროვილი საზამთროს ნაჭერი",
  "item.minecraft.bat_spawn_egg": "ღამურას გასაჩენი კვერცხი",
  "item.minecraft.bee_spawn_egg": "ფუტკრის გასაჩენი კვერცხი",
  "item.minecraft.blaze_spawn_egg": "იფრიტის გასაჩენი კვერცხი",
  "item.minecraft.cat_spawn_egg": "კატის გასაჩენი კვერცხი",
  "item.minecraft.cave_spider_spawn_egg": "გამოქვაბულის ობობის გასაჩენი კვერცხი",
  "item.minecraft.chicken_spawn_egg": "ქათმის გასაჩენი კვერცხი",
  "item.minecraft.cod_spawn_egg": "ვირთევზას გასაჩენი კვერცხი",
  "item.minecraft.cow_spawn_egg": "ძროხის გასაჩეკი კვერცხი",
  "item.minecraft.creeper_spawn_egg": "კრიპერის გასაჩეკი კვერცხი",
  "item.minecraft.dolphin_spawn_egg": "დელფინის გასაჩენი კვერცხი",
  "item.minecraft.donkey_spawn_egg": "ვირის გასაჩენი კვერცხი",
  "item.minecraft.drowned_spawn_egg": "ხრჩობილის გასაჩენი კვერცხი",
  "item.minecraft.elder_guardian_spawn_egg": "უძველესი მცველის გასაჩენი კვერცხი",
  "item.minecraft.enderman_spawn_egg": "ენდერმენის გასაჩენი კვერცხი",
  "item.minecraft.endermite_spawn_egg": "ენდერმიტის გასაჩენი კვერცხი",
  "item.minecraft.evoker_spawn_egg": "გამღვიძებლის გასაჩეკი კვერცხი",
  "item.minecraft.fox_spawn_egg": "მელიის გასაჩენი კვერცხი",
  "item.minecraft.ghast_spawn_egg": "გასტის გასაჩენი კვერცხი",
  "item.minecraft.guardian_spawn_egg": "მცველის გასაჩენი კვერცხი",
  "item.minecraft.hoglin_spawn_egg": "ჰოგლინის გასაჩენი კვერცხი",
  "item.minecraft.horse_spawn_egg": "ცხენის გასაჩენი კვერცხი",
  "item.minecraft.husk_spawn_egg": "გვამის გასაჩეკი კვერცხი",
  "item.minecraft.llama_spawn_egg": "ლამის გასაჩენი კვერცხი",
  "item.minecraft.magma_cube_spawn_egg": "მაგმა-კუბის გასაჩენი კვერცხი",
  "item.minecraft.mooshroom_spawn_egg": "სოკოს ძროხის გასაჩენი კვერცხი",
  "item.minecraft.mule_spawn_egg": "ჯორის გასაჩენი კვერცხი",
  "item.minecraft.ocelot_spawn_egg": "ოცელოტის გასაჩენი კვერცხი",
  "item.minecraft.panda_spawn_egg": "პანდას გასაჩენი კვერცხი",
  "item.minecraft.parrot_spawn_egg": "თუთიყუშის გასაჩენი კვერცხი",
  "item.minecraft.phantom_spawn_egg": "ფანტომის გასაჩენი კვერცხი",
  "item.minecraft.pig_spawn_egg": "ღორის გასაჩენი კვერცხი",
  "item.minecraft.piglin_spawn_egg": "პიგლინის გასაჩენი კვერცხი",
  "item.minecraft.pillager_spawn_egg": "მძარცველის გასაჩენი კვერცხი",
  "item.minecraft.polar_bear_spawn_egg": "პოლარული დათვის გასაჩენი კვერცხი",
  "item.minecraft.pufferfish_spawn_egg": "ფუგუს გასაჩენი კვერცხი",
  "item.minecraft.rabbit_spawn_egg": "კურდღლის გასაჩენი კვერცხი",
  "item.minecraft.ravager_spawn_egg": "გამანადგურებლის გასაჩენი კვერცხი",
  "item.minecraft.salmon_spawn_egg": "ორაგულის გასაჩენი კვერცხი",
  "item.minecraft.sheep_spawn_egg": "ცხვრის გასაჩენი კვერცხი",
  "item.minecraft.shulker_spawn_egg": "შალკერის გასაჩენი კვერცხი",
  "item.minecraft.silverfish_spawn_egg": "ვერცხლის თევზის გასაჩენი კვერცხი",
  "item.minecraft.skeleton_spawn_egg": "ჩონჩხის გასაჩენი კვერცხი",
  "item.minecraft.skeleton_horse_spawn_egg": "ჩონჩხ-ცხენის გასაჩენი კვერცხი",
  "item.minecraft.slime_spawn_egg": "ლორწოს გასაჩენი კვერცხი",
  "item.minecraft.spider_spawn_egg": "ობობის გასაჩენი კვერცხი",
  "item.minecraft.squid_spawn_egg": "რვაფეხის გასაჩენი კვერცხი",
  "item.minecraft.stray_spawn_egg": "მაწანწალის გასაჩენი კვერცხი",
  "item.minecraft.strider_spawn_egg": "სტრაიდერის გასაჩენი კვერცხი",
  "item.minecraft.trader_llama_spawn_egg": "მევაჭრეს ლამის გასაჩენი კვერცხი",
  "item.minecraft.tropical_fish_spawn_egg": "ტროპიკული თევზის გასაჩენი კვერცხი",
  "item.minecraft.turtle_spawn_egg": "კუს გასაჩენი კვერცხი",
  "item.minecraft.vex_spawn_egg": "მავნებლის გასაჩენი კვერცხი",
  "item.minecraft.villager_spawn_egg": "მაცხოვრებლის გასაჩენი კვერცხი",
  "item.minecraft.vindicator_spawn_egg": "გუშაგის გასაჩენი კვერცხი",
  "item.minecraft.wandering_trader_spawn_egg": "მოგზაური მევაჭრეს გასაჩენი კვერცხი",
  "item.minecraft.witch_spawn_egg": "კუდიანის გასაჩენი კვერცხი",
  "item.minecraft.wither_skeleton_spawn_egg": "ვიზერ-ჩონჩხის გასაჩენი კვერცხი",
  "item.minecraft.wolf_spawn_egg": "მგლის გასაჩენი კვერცხი",
  "item.minecraft.zoglin_spawn_egg": "ზოგლინის გასაჩენი კვერცხი",
  "item.minecraft.zombie_spawn_egg": "ზომბის გასაჩენი კვერცხი",
  "item.minecraft.zombie_horse_spawn_egg": "ზომბი-ცხენის გასაჩენი კვერცხი",
  "item.minecraft.zombie_villager_spawn_egg": "ზომბი-მაცხოვრებლის გასაჩენი კვერცხი",
  "item.minecraft.zombified_piglin_spawn_egg": "ზომბიფიცირებული პიგლინის გასაჩენი კვერცხი",
  "item.minecraft.experience_bottle": "ჯადოს ბოთლი",
  "item.minecraft.fire_charge": "ცეცხლოვანი ბურთი",
  "item.minecraft.writable_book": "წიგნი და ბუმბულის კალამი",
  "item.minecraft.written_book": "დაწერილი წიგნი",
  "item.minecraft.emerald": "ზურმუხტი",
  "item.minecraft.item_frame": "ნივთის ჩარჩო",
  "block.minecraft.flower_pot": "ყვავილის ქოთანი",
  "item.minecraft.carrot": "სტაფილო",
  "item.minecraft.potato": "კარტოფილი",
  "item.minecraft.baked_potato": "გამომცხვარი კარტოფილი",
  "item.minecraft.poisonous_potato": "შხამიანი კარტოფილი",
  "item.minecraft.map": "ცარიელი რუკა",
  "item.minecraft.golden_carrot": "ოქროს სტაფილო",
  "block.minecraft.skeleton_skull": "ჩონჩხის თავის ქალა",
  "block.minecraft.wither_skeleton_skull": "ვიზერ ჩონჩხის თავი",
  "block.minecraft.player_head": "მომხმარებლის თავი",
  "block.minecraft.zombie_head": "ზომბის თავი",
  "block.minecraft.creeper_head": "კრიპერის თავი",
  "block.minecraft.dragon_head": "დრაკონის თავი",
  "item.minecraft.carrot_on_a_stick": "სტაფილო ჯოხზე",
  "item.minecraft.warped_fungus_on_a_stick": "დაბრეცილი სოკო ანკესზე",
  "item.minecraft.nether_star": "ნეზერის ვარსკვლავი",
  "item.minecraft.pumpkin_pie": "გოგრის ღვეზელი",
  "item.minecraft.firework_rocket": "რაკეტა მაშხალა",
  "item.minecraft.firework_star": "მაშხალის ვარსკლავი",
  "item.minecraft.enchanted_book": "ჯადოსნური წიგნი",
  "item.minecraft.nether_brick": "ნეზერის აგური",
  "item.minecraft.quartz": "ნეზერის კვარცი",
  "item.minecraft.tnt_minecart": "ასაფეთქებლიანი ურიკა",
  "item.minecraft.hopper_minecart": "ძაბრიანი ურიკა",
  "item.minecraft.prismarine_shard": "პრიზმარინის ნატეხი",
  "item.minecraft.prismarine_crystals": "პრიზმარინის კრისტალი",
  "item.minecraft.rabbit": "უმი კურდღელი",
  "item.minecraft.cooked_rabbit": "შემწვარი კურდღელი",
  "item.minecraft.rabbit_stew": "კურდღლის წვნიანი",
  "item.minecraft.rabbit_foot": "კურდღლის ფეხი",
  "item.minecraft.rabbit_hide": "კურდღლის ტყავი",
  "item.minecraft.armor_stand": "აბჯრის სადგამი",
  "item.minecraft.iron_horse_armor": "ცხენის რკინის აბჯარი",
  "item.minecraft.golden_horse_armor": "ცხენის ოქროს ბრონი",
  "item.minecraft.diamond_horse_armor": "ცხენის ალმასის აბჯარი",
  "item.minecraft.leather_horse_armor": "ცხენის ტყავის ჯავშანი",
  "item.minecraft.lead": "თასმა",
  "item.minecraft.name_tag": "იარლიყი",
  "item.minecraft.command_block_minecart": "ბრძანების ბლოკიანი ურიკა",
  "item.minecraft.mutton": "უმი ცხვრის ხორცი",
  "item.minecraft.cooked_mutton": "შემწვარი ცხვრის ხორცი",
  "block.minecraft.white_banner": "თეთრი დროშა",
  "block.minecraft.orange_banner": "ნარინჯისფერი დროშა",
  "block.minecraft.magenta_banner": "იისფერი დროშა",
  "block.minecraft.light_blue_banner": "ღია-ლურჯი დროშა",
  "block.minecraft.yellow_banner": "ყვითელი დროშა",
  "block.minecraft.lime_banner": "სალათისფერი დროშა",
  "block.minecraft.pink_banner": "ვარდისფერი დროშა",
  "block.minecraft.gray_banner": "ნაცრისფერი დროშა",
  "block.minecraft.light_gray_banner": "ღია-ნაცრისფერი დროშა",
  "block.minecraft.cyan_banner": "ცისფერი დროშა",
  "block.minecraft.purple_banner": "ალისფერი დროშა",
  "block.minecraft.blue_banner": "ლურჯი დროშა",
  "block.minecraft.brown_banner": "ყავისფერი დროშა",
  "block.minecraft.green_banner": "მწვანე დროშა",
  "block.minecraft.red_banner": "წითელი დროშა",
  "block.minecraft.black_banner": "შავი დროშა",
  "item.minecraft.end_crystal": "ენდის კრისტალი",
  "item.minecraft.chorus_fruit": "ქორუსის ხილი",
  "item.minecraft.popped_chorus_fruit": "ქორუსის გახეთქილი ხილი",
  "item.minecraft.beetroot": "ჭარხალი",
  "item.minecraft.beetroot_seeds": "ჭარხლის თესლი",
  "item.minecraft.beetroot_soup": "ჭარხლის წვნიანი",
  "item.minecraft.dragon_breath": "დრაკონის სუნთქვა",
  "item.minecraft.splash_potion": "ასაფეთქებელი შეუქმნადი ხსნარი□ეფექტების გარეშე",
  "item.minecraft.spectral_arrow": "სპექტრალური ისარი",
  "item.minecraft.tipped_arrow": "შეუქმნადი დამუშავებული ისარი□ეფექტების გარეშე",
  "item.minecraft.lingering_potion": "შეუქმნადი მძიმე ხსნარი□ეფექტების გარეშე",
  "item.minecraft.shield": "ფარი",
  "item.minecraft.elytra": "ელიტრა",
  "item.minecraft.spruce_boat": "ნაძვის ნავი",
  "item.minecraft.birch_boat": "არყის ნავი",
  "item.minecraft.jungle_boat": "ჯუნგლის ხის ნავი",
  "item.minecraft.acacia_boat": "აკაციის ნავი",
  "item.minecraft.dark_oak_boat": "მუქი მუხის ნავი",
  "item.minecraft.totem_of_undying": "უკვდავობის ტოტემი",
  "item.minecraft.shulker_shell": "შულკერის გარსი",
  "item.minecraft.iron_nugget": "რკინის ნატეხი",
  "item.minecraft.knowledge_book": "ცოდნის წიგნი",
  "item.minecraft.debug_stick": "გამართვის ჯოხი",
  "item.minecraft.music_disc_13": "მუსიკალური დისკი□c418 - 13",
  "item.minecraft.music_disc_cat": "მუსიკალური დისკი□c418 - cat",
  "item.minecraft.music_disc_blocks": "მუსიკალური დისკი□c418 - blocks",
  "item.minecraft.music_disc_chirp": "მუსიკალური დისკი□c418 - chirp",
  "item.minecraft.music_disc_far": "მუსიკალური დისკი□c418 - far",
  "item.minecraft.music_disc_mall": "მუსიკალური დისკი□c418 - mall",
  "item.minecraft.music_disc_mellohi": "მუსიკალური დისკი□c418 - mellohi",
  "item.minecraft.music_disc_stal": "მუსიკალური დისკი□c418 - stal",
  "item.minecraft.music_disc_strad": "მუსიკალური დისკი□c418 - strad",
  "item.minecraft.music_disc_ward": "მუსიკალური დისკი□c418 - ward",
  "item.minecraft.music_disc_11": "მუსიკალური დისკი□c418 - 11",
  "item.minecraft.music_disc_wait": "მუსიკალური დისკი□c418 - wait",
  "item.minecraft.music_disc_pigstep": "მუსიკალური დისკი□ლენა რეინი - pigstep",
  "item.minecraft.trident": "სამკაპი□□როდესაც მთავარ ხელშია:□+8 შეტევის ზიანი□-2.9 შეტევის სიჩქარე",
  "item.minecraft.phantom_membrane": "ფანტომის ტყავი",
  "item.minecraft.nautilus_shell": "ნაუტილუსის ნიჟარა",
  "item.minecraft.heart_of_the_sea": "ზღვის გული",
  "item.minecraft.crossbow": "არბალეტი",
  "item.minecraft.suspicious_stew": "იდუმალი წვნიანი",
  "block.minecraft.loom": "დაზგა",
  "item.minecraft.flower_banner_pattern": "ბანერის მოხატულობა□ყვავილის ემბლემა",
  "item.minecraft.creeper_banner_pattern": "ბანერის მოხატულობა□კრიპერის ფიგურა",
  "item.minecraft.skull_banner_pattern": "ბანერის მოხატულობა□თავის ქალის ემბლემა",
  "item.minecraft.mojang_banner_pattern": "ბანერის მოხატულობა□რამე",
  "item.minecraft.globe_banner_pattern": "ბანერის მოხატულობა□გლობუსი",
  "item.minecraft.piglin_banner_pattern": "ბანერის მოხატულობა□დინგი",
  "block.minecraft.composter": "კომპოსტერი",
  "block.minecraft.barrel": "კასრი",
  "block.minecraft.smoker": "ქურა",
  "block.minecraft.blast_furnace": "ბრძმედი",
  "block.minecraft.cartography_table": "კარტოგრაფის მაგიდა",
  "block.minecraft.fletching_table": "მეიარაღეს მაგიდა",
  "block.minecraft.grindstone": "მლესავი ქვა",
  "block.minecraft.lectern": "კათედრა",
  "block.minecraft.smithing_table": "სამჭედლო მაგიდა",
  "block.minecraft.stonecutter": "ქვის მჭრელი",
  "block.minecraft.bell": "ზარი",
  "block.minecraft.lantern": "ლამპა",
  "block.minecraft.soul_lantern": "სულის ლამპარი",
  "item.minecraft.sweet_berries": "ტკბილი კენკრა",
  "block.minecraft.campfire": "კოცონი",
  "block.minecraft.soul_campfire": "სულის კოცონი",
  "block.minecraft.shroomlight": "შარას განათება",
  "item.minecraft.honeycomb": "ფიჭა",
  "block.minecraft.bee_nest": "ფუტკრის ბუდე",
  "block.minecraft.beehive": "ბეჰევი",
  "item.minecraft.honey_bottle": "თაფლის ბოთლი",
  "block.minecraft.honey_block": "თაფლის ბლოკი",
  "block.minecraft.honeycomb_block": "ფიჭის ბლოკი",
  "block.minecraft.lodestone": "მაგნეტიტი",
  "block.minecraft.netherite_block": "ნეზერიტის ბლოკი",
  "block.minecraft.ancient_debris": "უძველესი ნატეხები",
  "block.minecraft.target": "სამიზნე",
  "block.minecraft.crying_obsidian": "მტირალა ობსიდიანი",
  "block.minecraft.blackstone": "შავქვა",
  "block.minecraft.blackstone_slab": "შავქვის ფილა",
  "block.minecraft.blackstone_stairs": "შავქვის საფეხურები",
  "block.minecraft.gilded_blackstone": "მოოქრული შავქვა",
  "block.minecraft.polished_blackstone": "გაპრიალებული შავქვა",
  "block.minecraft.polished_blackstone_slab": "გაპრიალებული შავქვის ფილა",
  "block.minecraft.polished_blackstone_stairs": "გაპრიალებული შავქვის საფეხურები",
  "block.minecraft.chiseled_polished_blackstone": "გამოკვეთილი ნატიფი შავქვა",
  "block.minecraft.polished_blackstone_bricks": "გაპრიალებული შავქვის აგურები",
  "block.minecraft.polished_blackstone_brick_slab": "გაპრიალებული შავქვის აგურების ფილა",
  "block.minecraft.polished_blackstone_brick_stairs": "გაპრიალებული შავქვის აგურების საფეხურები",
  "block.minecraft.cracked_polished_blackstone_bricks": "გაბზარული გლუვი შავქვის აგური",
  "block.minecraft.respawn_anchor": "გაჩენის შუქურა",
}
export const ka_ge = items; 
